<template>
  <div class="pageHead" id="yblPageHead">
    <div class="children-head">
      <el-row class="pageHead-row">
        <el-col :span="13">
          <div class="left">
            <div class="title">{{title || $route.meta.title}}<slot name="route-name"></slot></div>
            <div class="describe">
              <slot name="describe"></slot>
            </div>
            <!-- <div class="route" v-if="!tabsCut">
              <div v-for="(item, index) in pageMenu" :key="index" class="item"
                :class="item.route===$route.path?'active':''" v-show="!item.disabled" @click="skip(item)">
                {{item.label}}
                <div v-if="item.route===$route.path" class="is-bottom" :style="`width:${item.label.length*14}px`"></div>
              </div>
            </div>
            <el-tabs v-model="tabsName" @tab-click="handleClick" v-else>
              <slot name="tabs"></slot>
            </el-tabs> -->
            <el-tabs v-model="tabsName" @tab-click="handleClick" v-if="tabsCut">
              <slot name="tabs"></slot>
            </el-tabs>
            <div class="route" v-if="pageMenu && pageMenu.length">
              <div v-for="(item, index) in pageMenu" :key="index" class="item"
                :class="item.route===$route.path?'active':''" v-show="!item.disabled" @click="skip(item)">
                {{item.label}}
                <div v-if="item.route===$route.path" class="is-bottom" :style="`width:${item.label.length*14}px`"></div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="11">
          <div class="pageHead-right">
            <slot name="right_btn"></slot>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { openNavUrl } from '@/utils'
export default {
  name: 'yblPageHead',
  props: {
    title: {
      type: String,
      default: () => ''
    },
    pageMenu: { // outChain:外链路由
      type: Array,
      default: () => []
    },
    tabsCut: {
      type: Boolean,
      default: () => false
    },
    activeName: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      tabsName: ''
    }
  },
  created () {
    this.tabsName = this.activeName
  },
  mounted () {
  },
  methods: {
    skip (item) {
      if (item.outChain) this.goToOuter(item.outChain, 'blank')
      else if (item.route !== this.$route.path) {
        openNavUrl(item.route, item.label, location.host, 'blank', false, 0, 'n11006')
      }
    },
    goToOuter (url, target = 'self') {
      openNavUrl(url, '', location.host, target)
    },
    handleClick () {
      this.$emit('tab-click', this.tabsName)
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/color.less";
.pageHead {
  // overflow: hidden;
  box-sizing: border-box;
  // padding: 14px 12px;
  background-color: #fff;
  // margin-bottom: 14px;
  border-radius: 1px;
  // margin-right: 12px;
  height: 60px;
  flex: 0 0 60px;
  .children-head {
    padding: 0 12px;
    height: 60px;
  }
  .left {
    height: 60px;
    line-height: 60px;
    display: flex;
    align-items: center;
    .title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }
    .describe {
      font-size: 12px;
      font-family: Microsoft YaHei;
      line-height: 12px;
      height: 12px;
      color: @routine-color;
      margin-left: 12px;
    }
    .route {
      margin-left: 30px;
      display: flex;
      align-items: center;
      .item {
        margin-right: 18px;
        color: @routine-color;
        font-size: 14px;
        position: relative;
        cursor: pointer;
        .is-bottom {
          position: absolute;
          height: 2px;
          bottom: 0px;
          left: 0;
          background-color: @color;
        }
        &.active {
          color: @color;
        }
      }
    }
    /deep/.el-tabs {
      margin-left: 30px;
    }
    /deep/.el-tabs__nav-wrap::after {
      height: 0;
    }
    /deep/.el-tabs__active-bar {
      height: 3px;
    }
    /deep/.el-tabs__header {
      margin-bottom: 0;
      font-size: 14px;
      color: @main-color;
      .is-active {
        color: @main-color;
      }
      .el-tabs__item {
        font-weight: 400;
      }
    }
  }
  .pageHead-right {
    display: flex;
    // justify-content: end;
    align-items: center;
    float: right;
    height: 60px;
    // line-height: 60px;
    // /deep/.exportTemplate + .el-button {
    //   margin-left: 10px;
    // }
    /deep/.exportTemplate + .el-button {
      margin-left: 10px;
    }
    /deep/.el-dropdown__buttons + .el-button {
      margin-left: 10px;
    }
    /deep/.el-dropdown__buttons {
      // margin: 0 10px;
      margin-left: 10px;
    }
    // /deep/.el-dropdown {
    //   display: flex;
    //   align-items: center;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageHead.vue